import type { PartialDeep } from 'type-fest';
import { Configuration } from '../defaultConfig';

const chainConfig: PartialDeep<Configuration> = {};

export default chainConfig;
